import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import useCache from '../../app/useCache';
import { CachedEntity } from '../../app/cacheSlice';
import { userDataSelected } from '../../app/userSlice';
import { useCurrentUser } from '../../app/useCurrentUser';
import RoleSelector from '../common/RoleSelector';

export default function NewUserRolesPanel() {
    const dispatch = useAppDispatch();
    const { data } = useAppSelector(store => store.user);
    const roles = useCache(CachedEntity.Role);
    const [isAdmin] = useCurrentUser();

    return (
        <React.Fragment>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h5" color="primary">
                        Roles
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <RoleSelector
                        roles={roles}
                        selectedIds={data?.roleIds ?? []}
                        onChange={(ids) => data && dispatch(userDataSelected({ ...data, roleIds: ids }))}
                        disabled={!isAdmin}
                        height={380}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
